(() => {
  class ActionButtonContents extends HTMLElement {
    connectedCallback() {
      this._text = this.querySelector('.action-button-contents__text');
      this._spinner = this.querySelector('.action-button-contents__spinner');
      this.hideLoadingState();
    }

    showLoadingState() {
      // "visibility: hidden" instead of "display: none" so the rendered size of the button doesn't
      // change.
      this._text.style.visibility = 'hidden';
      this._spinner.classList.remove('hidden');
    }

    hideLoadingState() {
      this._text.style.removeProperty('visibility');
      this._spinner.classList.add('hidden');
    }
  }

  if (!customElements.get('action-button-contents')) {
    customElements.define('action-button-contents', ActionButtonContents);
  }
})();
